import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { ArrowDownUp } from "lucide-react";

export function StatsMatrix({ data }) {
  const [sort, setSort] = useState({ key: "total", dir: -1 });
  const val = (r, k) => (k === "name" ? r.name : k in r ? r[k] : r.by_mansione[k] || 0);
  const rows = [...data.students].sort((a, b) => {
    const x = val(a, sort.key), y = val(b, sort.key);
    return (typeof x === "string" ? x.localeCompare(y) : x - y) * sort.dir;
  });
  const colMax = Object.fromEntries(data.mansioni.map((m) => [m.id, Math.max(1, ...data.students.map((r) => r.by_mansione[m.id] || 0))]));
  const Th = ({ k, children, className = "" }) => (
    <th className={`px-2 py-2 text-left cursor-pointer select-none whitespace-nowrap ${className}`} onClick={() => setSort({ key: k, dir: sort.key === k ? -sort.dir : -1 })} data-testid={`stats-sort-${k}`}>
      {children}{sort.key === k && <ArrowDownUp size={10} className="inline ml-1 text-stone-400"/>}
    </th>
  );
  return (
    <Card className="border border-stone-200 shadow-none rounded-xl overflow-x-auto" data-testid="stats-matrix">
      <table className="w-full text-sm">
        <thead><tr className="bg-stone-50 text-[11px] uppercase tracking-wider text-stone-500">
          <Th k="name" className="sticky left-0 bg-stone-50 min-w-[180px]">Studente</Th>
          {data.mansioni.map((m) => <Th key={m.id} k={m.id}><span className="inline-block w-2 h-2 rounded-full mr-1" style={{ background: m.color }}/>{m.name}</Th>)}
          <Th k="total">Totale</Th><Th k="days">Giorni</Th><Th k="minutes">Ore</Th><Th k="as_substitute">Sostituzioni</Th><Th k="replaced">Sostituito</Th>
        </tr></thead>
        <tbody className="divide-y divide-stone-100">
          {rows.map((r) => (
            <tr key={r.student_id} data-testid={`stats-matrix-row-${r.student_id}`}>
              <td className="px-2 py-1.5 sticky left-0 bg-white truncate max-w-[220px]">{r.name}</td>
              {data.mansioni.map((m) => {
                const v = r.by_mansione[m.id] || 0;
                return <td key={m.id} className="px-2 py-1.5 text-center font-mono text-xs" style={{ background: v ? `${m.color}${Math.round(20 + (v / colMax[m.id]) * 60).toString(16).padStart(2, "0")}` : undefined }}>{v || "·"}</td>;
              })}
              <td className="px-2 py-1.5 font-mono font-semibold">{r.total}</td>
              <td className="px-2 py-1.5 font-mono text-xs">{r.days}</td>
              <td className="px-2 py-1.5 font-mono text-xs">{(r.minutes / 60).toFixed(1)}</td>
              <td className="px-2 py-1.5 font-mono text-xs">{r.as_substitute}</td>
              <td className="px-2 py-1.5 font-mono text-xs">{r.replaced}</td>
            </tr>
          ))}
        </tbody>
        <tfoot><tr className="bg-stone-50 text-xs font-medium">
          <td className="px-2 py-2 sticky left-0 bg-stone-50">Totale mansione</td>
          {data.mansioni.map((m) => <td key={m.id} className="px-2 py-2 text-center font-mono" title={`${m.students} studenti · ${m.hours} ore`}>{m.count}</td>)}
          <td className="px-2 py-2 font-mono">{data.summary.turni}</td><td colSpan={4}/>
        </tr></tfoot>
      </table>
    </Card>
  );
}
